import { loadAssessmentItems, loadScoring } from './assessmentItemLoader';

const LIKERT_5 = [
	{ value: 1, label: 'Strongly disagree' },
	{ value: 2, label: 'Disagree' },
	{ value: 3, label: 'Neutral' },
	{ value: 4, label: 'Agree' },
	{ value: 5, label: 'Strongly agree' }
];

const FREQ_5 = [
	{ value: 1, label: 'Never' },
	{ value: 2, label: 'Rarely' },
	{ value: 3, label: 'Sometimes' },
	{ value: 4, label: 'Often' },
	{ value: 5, label: 'Very often' }
];

const CONF_5 = [
	{ value: 1, label: 'Not at all' },
	{ value: 2, label: 'Slightly' },
	{ value: 3, label: 'Somewhat' },
	{ value: 4, label: 'Very' },
	{ value: 5, label: 'Extremely' }
];

function mapItemToQuestion(item, index, stagePrefix) {
	const id = `${stagePrefix}${item.id}`;
	const common = { id, domainId: item.domainId, elementId: item.elementId };
	if (item.format === 'forced') {
		// Two-option forced-choice A/B
		return {
			...common,
			type: 'forcedChoice',
			question: item.text || 'Choose the option most like you',
			options: item.choices.map(choice => ({ value: choice.elementId, label: choice.label }))
		};
	}
	// Likert-like single-scale formats
	let options = LIKERT_5;
	if (item.format === 'freq') options = FREQ_5;
	if (item.format === 'conf') options = CONF_5;
	return {
		...common,
		type: 'likert',
		question: item.text,
		options
	};
}

function shuffle(array) {
	const a = [...array];
	for (let i = a.length - 1; i > 0; i -= 1) {
		const j = Math.floor(Math.random() * (i + 1));
		[a[i], a[j]] = [a[j], a[i]];
	}
	return a;
}

export function generateStage1Questions(totalCount = 40) {
	const items = loadAssessmentItems(1);
	const mapped = items.map((it, idx) => mapItemToQuestion(it, idx, 's1_'));
	return shuffle(mapped).slice(0, Math.min(totalCount, mapped.length));
}

// For Stage 2 we currently use the cross-domain bank. The topElementIds are accepted but not strictly required.
export function generateStage2Questions(topElementIds = [], perElementCount = 4) {
	const items = loadAssessmentItems(2);
	const mapped = items.map((it, idx) => mapItemToQuestion(it, idx, 's2_'));
	// Aim for ~topElementIds.length * perElementCount, else default to 30
	const desired = topElementIds.length > 0 ? Math.min(mapped.length, topElementIds.length * perElementCount) : Math.min(mapped.length, 30);
	return shuffle(mapped).slice(0, desired);
}

export function getScoring(stage = 1) {
	return loadScoring(stage);
}
